export const soulAddress = '0x3ff1ae3ff05d452ef3e26a883158d7aad95231db';
export const soulDetailAddress = '0x988C52043B1151f9502670150df7Cf6008558aF2';
export const KogeAddress = '0xe6df05ce8c8301223373cf5b969afcb1498c5528';
export const nftAddress = '0x57b81C140BdfD35dbfbB395360a66D54a650666D';
export const govBNBAddress = '0x0000000000000000000000000000000000002005';